import React, { useEffect, useState } from "react";
import { useAxios } from "../../../../../hooks/useAxios";
import { Wrap } from "./style";
import { useHousesContext } from "../../../../../context/Houses";
import { useQuery } from "react-query";

export default function Edit({ onClose, id }) {
  const [{ house }, dispatch] = useHousesContext();
  const { request } = useAxios();
  useQuery(
    ["fetIndividualHouse"],
    () =>
      request({
        url: `/v1/houses/${id}`,
      }),
    {
      onSuccess: (res) => {
        res?.data?.success &&
          dispatch({ type: "setHouse", payload: res?.data?.data });
      },
      onError: (err) => console.log(err),
    }
  );
  return (
    <Wrap>
      <Wrap.Title>Edit Your House</Wrap.Title>

      <Wrap.Card>
        <Wrap.CardTitle>Contact Information</Wrap.CardTitle>
        <Wrap.Items>
          <Wrap.Item>
            <span>House Title</span>
            <Wrap.Input />
          </Wrap.Item>
          <Wrap.Item>
            <span>Type</span>
            <Wrap.Select />
          </Wrap.Item>
          <Wrap.Item>
            <span>Property Description</span>
            <Wrap.Input />
          </Wrap.Item>
        </Wrap.Items>
        <Wrap.CardTitle>Price</Wrap.CardTitle>

        <Wrap.Items>
          <Wrap.Item>
            <span>Price</span>
            <Wrap.Input />
          </Wrap.Item>
          <Wrap.Item>
            <span>Sale Price</span>
            <Wrap.Input />
          </Wrap.Item>
        </Wrap.Items>
        <Wrap.CardTitle>Location</Wrap.CardTitle>
        <Wrap.Items>
          <Wrap.Item>
            <span>Country</span>
            <Wrap.Input />
          </Wrap.Item>
          <Wrap.Item>
            <span>City</span>
            <Wrap.Input />
          </Wrap.Item>
          <Wrap.Item>
            <span>Region</span>
            <Wrap.Input />
          </Wrap.Item>
          <Wrap.Item>
            <span>Zip Code</span>
            <Wrap.Input />
          </Wrap.Item>
        </Wrap.Items>
        <Wrap.CardTitle>House Details</Wrap.CardTitle>

        <Wrap.Items>
          <Wrap.Item>
            <span>Area</span>
            <Wrap.Input />
          </Wrap.Item>
          <Wrap.Item>
            <span>Bath</span>
            <Wrap.Input />
          </Wrap.Item>
          <Wrap.Item>
            <span>Rooms</span>
            <Wrap.Input />
          </Wrap.Item>
        </Wrap.Items>
        <Wrap.Items>
          <Wrap.Item>
            <span>Garage</span>
            <Wrap.Input />
          </Wrap.Item>
        </Wrap.Items>
      </Wrap.Card>

      <Wrap.Buttons>
        <Wrap.Button mr="auto" onClick={onClose}>
          Cancel
        </Wrap.Button>
        <Wrap.Button color="#fff" bg="#313E47">
          Done
        </Wrap.Button>
      </Wrap.Buttons>
    </Wrap>
  );
}
